import { useEffect, useState } from "react";
import { useCacheStorage } from "@/setup/frontend/storage/CacheStorageContext";

const PENDING_TOTP_SECRET_STORAGE_KEY = "vcg-pending-totp-secret";

/**
 * Persists the secret of an in-progress authenticator app setup so the setup can be
 * restored if the mobile web view is reloaded while the user is away in their authenticator app.
 * The persisted secret is read once on mount.
 */
export function usePendingTOTPSecret() {
	const cacheStorage = useCacheStorage();
	const [restoredSecretKey, setRestoredSecretKey] = useState<string | null>(
		null,
	);

	useEffect(() => {
		cacheStorage
			.getItem(PENDING_TOTP_SECRET_STORAGE_KEY)
			.catch(() => null)
			.then(setRestoredSecretKey);
	}, []);

	return {
		restoredSecretKey,
		save: (secretKey: string) =>
			cacheStorage
				.setItem(PENDING_TOTP_SECRET_STORAGE_KEY, secretKey)
				.catch(() => {}),
		clear: () =>
			cacheStorage.removeItem(PENDING_TOTP_SECRET_STORAGE_KEY).catch(() => {}),
	};
}
